<template>
    <a-file-window
        ref="aFileWindow"
        :pageWidth="afilePageWidth"
        :pageHeight="afilePageHeight"
        :AFileConfig="AFileConfig"
        @onChangeSize="resizeAfile"
        @pointerdown.stop="focusWindow"
        :wheelHandler="wheelHandler"
        :onPointerDown="onPointerDown"
        :onPointerMove="onPointerMove"
        :onPointerUp="onPointerUp"
        v-show="show"
    >
        <div id="svg-clip-path" ref="afile_container">
            <div id="svg-scaler" ref="svg_scaler">
                <div id="svg-container" ref="svg_container">
                    <div class="background"></div>
                    <div v-show="showSeries" id="page-svg" class="page-svg" ref="page_svg"></div>
                    <div
                        class="afile-background"
                        v-for="(item, index) in totalFrameSrc"
                        :key="index"
                        :ref="'pageSvg'"
                        :name="index"
                        :class="{ visible: (index == nowFrame && item.finish == true) || !showSeries, hidden: index != nowFrame || showSeries }"
                    ></div>
                </div>
            </div>
        </div>
        <div class="afile-page-container" ref="page_container">
            <div id="page" class="page">
                <div ref="animation_container" style="background-color: rgba(255, 255, 255, 0); width: 1393px; height: 936px">
                    <canvas
                        :id="afileCanvasId"
                        ref="canvas"
                        width="1393"
                        height="936"
                        style="position: absolute; display: none; background-color: rgba(255, 255, 255, 0)"
                    ></canvas>
                    <div
                        id="afile_dom_overlay_container"
                        ref="dom_overlay_container"
                        style="pointer-events: none; overflow: hidden; width: 1393px; height: 936px; position: absolute; left: 0px; top: 0px; display: none"
                    ></div>
                </div>
                <div ref="preload_div" style="position: absolute; top: 0; left: 0; display: inline-block; height: 936px; width: 1393px; text-align: center">
                    <span style="display: inline-block; height: 100%; vertical-align: middle"></span>
                    <img src="../../assets/_preloader.gif" style="vertical-align: middle; max-height: 100%" />
                </div>
            </div>
            <div
                class="zoom-part-zone"
                ref="zoomPartZone"
                :style="{
                    left: zoomLeft + 'px',
                    top: zoomTop + 'px',
                    width: zoomWidth + 'px',
                    height: zoomHeight + 'px',
                    transformOrigin: 'left top',
                    transform: 'rotateX(' + rotateX + 'deg) ' + 'rotateY(' + rotateY + 'deg) ',
                }"
            ></div>
        </div>
    </a-file-window>
</template>

<script>
import AFileLoader from "@/js/afile_loader";
import PageItemControl from "../../js/pageItem_control";
import AFileWindow from "./AFileWindow.vue";
import mitt from "mitt";
import { focusStore } from "../../js/store/nowFocusStore";
import PainterProxy from "../../js/painter/proxy";
import { store } from "../../store";
import { TOOLS } from "../../js/toolbar/tools";
import PageMove from "../../js/book_page/page_move";
import TouchScale from "../../js/book_page/touch_scale";
import AFileZoomPart from "../../js/book_page/afile_zoom_part";
import EventBus from "../../js/event_bus";
import { windowContentScaleX, windowContentScaleY } from "../../js/common/content_scale";
import { afileStore } from '../../js/store/afileStore';

export default {
    name: "AFile",
    data: function () {
        return {
            show: false,
            pageLoader: null,
            pageItemControl: null,
            maximum: true,
            top: 0,
            left: 0,
            width: 1920,
            height: 1017,
            afilePageWidth: 1393, //1856,
            afilePageHeight: 856,
            afileRoot: null,

            deltaMouse: { x: 0, y: 0 },
            resizeOrigon: "",
            maxWidth: 0,
            maxHeight: 0,
            emitter: mitt(),
            totalFrameSrc: [],
            nowFrame: 0,
            showSeries: true,
            firstFrame: 0,
            firstFrameFinish: false,

            pageContainer: null,
            svgContainer: null,
            containerScale: 1,
            afileContainer: null,

            store,
            currentPageTool: undefined,
            pageToolMap: new Map(),

            pagePercentPoint: {},

            zoomLeft: 0,
            zoomTop: 0,
            zoomWidth: 0,
            zoomHeight: 0,
            rotateX: 0,
            rotateY: 0,

            scaleX: 1,
            scaleY: 1,

            canvasContainer: null,
            touchPointList: [],
            afileStore,

            // 假資料，避免
            containerPosition: {x: 0, y: 0},
        };
    },
    props: ["AFileConfig", "wheelHandler"],
    components: {
        AFileWindow,
    },
    mounted: function () {
        console.log("init Afile");
        const self = this;
        this.pageLoader = new AFileLoader();
        this.pageLoader.startFrame = this.AFileConfig.startFrame;
        this.pageLoader.targetFrame = this.AFileConfig.frame;
        this.nowFrame = this.AFileConfig.frame;
        this.firstFrame = this.AFileConfig.frame;
        this.pageLoader.setAfile(this);

        let canvas = this.$refs.canvas;
        let animation_container = this.$refs.animation_container;
        let dom_overlay_container = this.$refs.dom_overlay_container;
        let preload_div = this.$refs.preload_div;
        let page_svg = this.$refs.page_svg;

        this.pageItemControl = new PageItemControl(this.pageLoader);

        window.currentPageItemControl = this.pageItemControl;
        window.aFileControl.loadingAfile.itemControl = this.pageItemControl;

        this.pageLoader.initFinishCallback = function () {
            self.pageLoader.loadNewPage([self.AFileConfig.fileName]);
        };
        this.pageLoader.onStageResize = function (scaleX, scaleY) {
            self.$refs.svg_container.style.transform = `scale(${scaleX / window.devicePixelRatio}, ${scaleY / window.devicePixelRatio})`;
            self.scaleX = scaleX / window.devicePixelRatio;
            self.scaleY = scaleY / window.devicePixelRatio;
        };

        this.pageLoader.initPageContainers(canvas, animation_container, dom_overlay_container, preload_div, page_svg);

        let width = window.pageWidth - 64;
        let height = window.pageHeight - 80;

        this.maxWidth = window.pageWidth;
        this.maxHeight = window.pageHeight;
        this.pageLoader.setAFileSize(width, height);

        this.width = window.pageWidth;
        this.height = window.pageHeight;

        this.afileRoot = this.$refs.afileRoot;

        this.focusWindow();

        this.pageContainer = this.$refs.page_container;
        this.svgScaler = this.$refs.svg_scaler;
        this.svgContainer = this.$refs.svg_container;
        this.afileContainer = this.$refs.afile_container;

        this.pageToolMap.set(TOOLS.ZOOM_PART.TOOL, new AFileZoomPart(this));
        this.pageToolMap.set(TOOLS.SELECTION.TOOL, new PageMove(this));
        this.pageToolMap.set("touch_scale", new TouchScale(this, "AFile"));
        this.currentPageTool = this.pageToolMap.get(this.store.nowTool);

        this.canvasContainer = PainterProxy.getInstance().getCurrentPainter().painter.canvas.wrapperEl;
    },
    methods: {
        wheelHandler(e) {
            this.focusWindow();
            let svgContainerBoundingRect = this.svgContainer.getBoundingClientRect();
            let pageContainerBoundingRect = this.pageContainer.getBoundingClientRect();
            if (e.deltaY > 0) {
                this.containerScale -= 0.1;
                this.containerScale = Math.max(this.containerScale, 1);
            } else {
                this.containerScale += 0.1;
                this.containerScale = Math.min(this.containerScale, 10);
            }
            let targetPoint = {
                x: e.clientX - svgContainerBoundingRect.x,
                y: e.clientY - svgContainerBoundingRect.y,
            };

            this.zoom(
                targetPoint.x * windowContentScaleX.value,
                targetPoint.y * windowContentScaleY.value,
                this.containerScale,
                e.clientX - pageContainerBoundingRect.x,
                e.clientY - pageContainerBoundingRect.y
            );
        },
        onPointerDown(e) {
            if (!this.currentPageTool) return;
            if (e.button !== 0 && e.pointerType === "mouse") return;
            this.touchPointList.push(e);
            if (e.pointerType === "touch" && store.nowTool == TOOLS.SELECTION.TOOL) {
                store.canTouchAction = true;
                switch (true) {
                    case this.touchPointList.length == 2:
                        store.nowTool = "touch_scale";
                        break;
                }
            }
            this.currentPageTool.onPointerDown(e);
            EventBus.getInstance()._app.setWindowPointerup(this.onPointerUp.bind(this));
        },
        onPointerMove(e) {
            if (!this.currentPageTool) return;
            if (e.pointerType === "touch" && store.nowTool == TOOLS.SELECTION.TOOL) {
                switch (true) {
                    case this.touchPointList.length == 2:
                        store.nowTool = "touch_scale";
                        break;
                }
            }
            this.currentPageTool.onPointerMove(e);
        },
        onPointerUp(e) {
            if (!this.currentPageTool) return;
            if (e.pointerType === "touch" && store.nowTool == TOOLS.SELECTION.TOOL) {
                switch (true) {
                    case this.touchPointList.length == 2:
                        store.nowTool = "touch_scale";
                        break;
                }
                this.touchPointList = [];
            }
            this.currentPageTool.onPointerUp(e);
        },
        resizeAfile: function (width, height) {
            let newWidth = width - 64;
            let newHeight = height - 80;
            // this.$refs.aFileWindow.updateCanvasSize(newWidth, newHeight)
            this.pageLoader.setAFileSize(newWidth, newHeight);
            this.pageLoader.triggerResize();

            this.afilePageWidth = this.$refs.page_container.clientWidth;
            this.afilePageHeight = this.$refs.page_container.clientHeight;

            this.backPosition();
        },
        handleLoadData(e) {
            console.log("load start", e);
        },
        onloadBackground(item, index) {
            item.finish = true;
            if (index == this.firstFrame) {
                this.showSeries = false;
            }
        },
        focusWindow() {
            this.$refs.aFileWindow.setFocusPainter();
            setTimeout(() => {
                focusStore.setNowPageItemControl(this.pageItemControl, this.AFileConfig.type);
                focusStore.setFocusBookPage(this);
            });
        },
        //#region 縮放功能
        zoomCornerRightTop() {
            this.containerScale = 2;
            let svgContainerBoundingRect = this.svgContainer.getBoundingClientRect();
            this.zoom(
                svgContainerBoundingRect.width * 0.75 * windowContentScaleX.value,
                svgContainerBoundingRect.height * 0.25 * windowContentScaleY.value,
                this.containerScale
            );
        },
        zoomCornerLeftTop() {
            this.containerScale = 2;
            let svgContainerBoundingRect = this.svgContainer.getBoundingClientRect();
            this.zoom(
                svgContainerBoundingRect.width * 0.25 * windowContentScaleX.value,
                svgContainerBoundingRect.height * 0.25 * windowContentScaleY.value,
                this.containerScale
            );
        },
        zoomCornerRightBottom() {
            this.containerScale = 2;
            let svgContainerBoundingRect = this.svgContainer.getBoundingClientRect();
            this.zoom(
                svgContainerBoundingRect.width * 0.75 * windowContentScaleX.value,
                svgContainerBoundingRect.height * 0.75 * windowContentScaleY.value,
                this.containerScale
            );
        },
        zoomCornerLeftBottom() {
            this.containerScale = 2;
            let svgContainerBoundingRect = this.svgContainer.getBoundingClientRect();
            this.zoom(
                svgContainerBoundingRect.width * 0.25 * windowContentScaleX.value,
                svgContainerBoundingRect.height * 0.75 * windowContentScaleY.value,
                this.containerScale
            );
        },
        zoomNormal() {
            this.containerScale = 1;
            let svgContainerBoundingRect = this.svgContainer.getBoundingClientRect();
            this.zoom(
                svgContainerBoundingRect.width * 0.5 * windowContentScaleX.value,
                svgContainerBoundingRect.height * 0.5 * windowContentScaleY.value,
                this.containerScale
            );
            // }
        },
        //#endregion
        zoom(x, y, scale, alignX, alignY, updatePercent = true) {
            scale = Math.max(scale, 1);
            scale = Math.min(scale, 10);
            this.containerScale = scale;

            const svgContainerBoundingRect = this.svgContainer.getBoundingClientRect();
            const px = x / (svgContainerBoundingRect.width * windowContentScaleX.value);
            const py = y / (svgContainerBoundingRect.height * windowContentScaleY.value);

            this.scaleContainer(this.containerScale);
            let newSvgContainerBoundingRect = this.svgContainer.getBoundingClientRect();
            let pageContainerBoundingRect = this.$refs.animation_container.getBoundingClientRect();

            let newLeft, newTop;
            if (alignX && alignY) {
                newLeft = (alignX - newSvgContainerBoundingRect.width * px) / windowContentScaleX.value;
                newTop = (alignY - newSvgContainerBoundingRect.height * py) / windowContentScaleY.value;
            } else {
                newLeft = (pageContainerBoundingRect.width * 0.5 - newSvgContainerBoundingRect.width * px) / windowContentScaleX.value;
                newTop = (pageContainerBoundingRect.height * 0.5 - newSvgContainerBoundingRect.height * py) / windowContentScaleY.value;
                // this.pagePercentPoint.x = px;
                // this.pagePercentPoint.y = py;
            }

            let fixedPoint = this.fitBorder(newLeft, newTop);

            this.move(fixedPoint.x, fixedPoint.y);

            if (updatePercent) {
                let newPx =
                    (pageContainerBoundingRect.width * 0.5 - fixedPoint.x * windowContentScaleX.value * store.currentBookPageScale.x) /
                    newSvgContainerBoundingRect.width;
                let newPy =
                    (pageContainerBoundingRect.height * 0.5 - fixedPoint.y * windowContentScaleY.value * store.currentBookPageScale.y) /
                    newSvgContainerBoundingRect.height;
                this.pagePercentPoint.x = newPx;
                this.pagePercentPoint.y = newPy;
            }

            this.pageLoader.setStagePosition(fixedPoint);
            const canvasScaleX = this.canvasContainer.dataset.scaleX || 1;
            const canvasScaleY = this.canvasContainer.dataset.scaleY || 1;
            this.scalePaintAndMove(this.containerScale, fixedPoint.x / canvasScaleX, fixedPoint.y / canvasScaleY);
        },
        move(x, y) {
            if (x != null && x != undefined) this.svgScaler.style.left = x + "px";
            if (y != null && y != undefined) this.svgScaler.style.top = y + "px";
        },
        scaleContainer: function (scale) {
            this.pageLoader.scaleContainers(scale);
            this.pageLoader.mutiAntialiasing();
            this.svgScaler.style.transform = `scale(${scale})`;
        },
        /**
         * 縮放畫布並且移動畫布 set transform with matrix
         * @param {number} scale scale painter canvas
         * @param {number} x translate x distance
         * @param {number} y translate y distance
         */
        scalePaintAndMove(scale, x, y) {
            PainterProxy.getInstance().updateViewportTransform(x, y, scale);
        },
        fitBorder: function (x, y) {
            let svgContainerBoundingRect = this.svgContainer.getBoundingClientRect();
            let pageContainerBoundingRect = this.$refs.page_container.getBoundingClientRect();

            let limitLeft = 0;
            let limitRight = pageContainerBoundingRect.width - svgContainerBoundingRect.width;
            let limitBottom = pageContainerBoundingRect.height - svgContainerBoundingRect.height;

            limitLeft = limitLeft / windowContentScaleX.value;
            limitRight = limitRight / windowContentScaleX.value;
            limitBottom = limitBottom / windowContentScaleY.value;

            if (x > limitLeft) {
                x = limitLeft;
            }
            if (x < limitRight) {
                x = limitRight;
            }
            if (y > 0) {
                y = 0;
            }
            if (y <= limitBottom) {
                y = limitBottom;
            }

            return { x: Math.round(x), y: Math.round(y) };
        },
        backPosition() {
            if (this.svgContainer) {
                let svgContainerBoundingRect = this.svgContainer.getBoundingClientRect();
                const x = svgContainerBoundingRect.width * this.pagePercentPoint.x * windowContentScaleX.value || svgContainerBoundingRect.width * 0.5;
                const y = svgContainerBoundingRect.height * this.pagePercentPoint.y * windowContentScaleY.value || svgContainerBoundingRect.height * 0.5;
                
                const self = this;
                if(afileStore.immediatelyScale) {
                    self.zoom(Math.floor(x), Math.floor(y), self.containerScale, null, null, false);
                }else {
                    setTimeout(function () {
                        self.zoom(Math.floor(x), Math.floor(y), self.containerScale, null, null, false);
                        afileStore.immediatelyScale = true;
                    });
                }
            }
        },
    },
    computed: {
        windowBtnClass() {
            return this.maximum == true ? "windowed" : "maximum";
        },
        afileCanvasId() {
            return "afile-canvas-" + this.AFileConfig.id;
        },
    },
    beforeUnmount() {
        // const afileStage = this.pageLoader.pageStage;
        // const canvas = afileStage.canvas;

        // this.pageLoader.createjs.Ticker.removeAllEventListeners();
        // afileStage.removeAllChildren();
        // afileStage.update();
        // afileStage.removeAllEventListeners();
        // if (afileStage.parent) {
        //     afileStage.parent.removeChild(afileStage);
        // }
        
        // if (canvas) {
        //     window.cancelAnimationFrame(canvas.requestAnimationFrameId);
        //     canvas.parentNode.removeChild(canvas);
        // }

        //this.pageLoader.pageStage.clear();
        this.pageLoader.onStageResize = null;
        this.pageLoader = null;
        focusStore.setNowPageItemControl();
    },
    watch: {
        totalFrameSrc: {
            handler: function () {
                console.log(this.$refs.pageSvg);
            },
        },
        "store.nowTool": {
            handler: function () {
                this.currentPageTool = this.pageToolMap.get(store.nowTool);
            },
        },
        show: {
            handler: function (newValue) {
                if (newValue) {
                    setTimeout(() => {
                        this.$refs.aFileWindow.maximize();
                    });
                }
            },
        },
    },
};
</script>

<style scoped>
.page-svg {
    /* visibility: hidden; */
    position: absolute;
    width: 2560px;
    height: 1440px;
    top: 0px;
    left: 0px;
}

.page {
    width: fit-content;
    height: fit-content;
}

#page-container {
    position: absolute;
    display: flex;
    justify-content: center;
    top: 0px;
    z-index: 2;
}

#svg-container {
    position: absolute;
    transform-origin: top left;
    display: block;
    justify-content: flex-start;
    z-index: 1;
}

#svg-scaler {
    position: absolute;
    transform-origin: top left;
}

.page-svg {
    transform-origin: top left;
}

#svg-clip-path {
    position: absolute;
    width: 100%;
    height: 100%;
}

.afile-background {
    position: absolute;
    top: 0px;
    left: 0px;
}

.visible {
    z-index: 2;
}

.hidden {
    z-index: -1;
    display: none;
    top: 9999px;
    left: 9999px;
}

.background {
    width: 2560px;
    height: 1440px;
}

.zoom-part-zone {
    position: absolute;
    background-color: rgba(0, 255, 255, 0.33);
    pointer-events: none;
    z-index: 999;
}
</style>
